import { createFileRoute } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import ProductCreateForm from "./-form";
import { ProductCrumbs } from "./-crumbs";

export const Route = createFileRoute(
  "/_private/_patient-pharmcy-360/product/create",
)({
  component: ProductCreatePage,
});

function ProductCreatePage() {
  return (
    <div>
      <title>Create Product - Legrande Health Portal</title>
      <ProductCrumbs />
      {/* Product form */}
      <Card>
        <CardHeader>
          <CardTitle>Add Product</CardTitle>
          <CardDescription>Enter product details below.</CardDescription>
        </CardHeader>
        <CardContent>
          <ProductCreateForm />
        </CardContent>
      </Card>
    </div>
  );
}
